import { Component, OnInit, inject } from '@angular/core';
import { TakeUntilDestroy } from '@app/shared/decorators/take-until-destroy.decorator';
import { Modal, ModalConfig, ModalType } from '@app/shared/models/modal.model';
import { EventManager } from '@app/shared/utils/event-manager';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { LoggerService } from '@app/shared/services/logger.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedModule } from '@app/shared/shared.module';
import { DisplayComponent } from '@app/shared/components/display/display.component';

@TakeUntilDestroy
@Component({
  selector: 'slotcom-rolling-offers-bonus',
  standalone: true,
  imports: [ButtonComponent, SharedModule, DisplayComponent],
  templateUrl: './rolling-offers-bonus.component.html',
  styleUrl: './rolling-offers-bonus.component.scss',
})
export class RollingOffersBonusComponent implements OnInit {
  private eventManager = inject(EventManager);
  private translateService = inject(TranslateService);
  loggerService = inject(LoggerService);
  rollingOffersData = inject<ModalConfig>(MAT_DIALOG_DATA);

  componentDestroy: () => Observable<unknown>;
  lang: string;

  ngOnInit(): void {
    this.lang = this.translateService.currentLang;
  }

  closeModal(): void {
    this.eventManager.closeModal(new Modal(this.rollingOffersData.id, ModalType.Persisted, this.rollingOffersData));
  }
}
